(function () {
    'use strict';

    angular
        .module('AuthenticationControllers', [])
        .controller('RetryAuthenticationController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        $scope.retry = function () {
            window.location.reload();
        };
    }
})();